var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircularTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 8.4L13.125 7H15.875L17.25 8.4H20V9.8H9V8.4H11.75ZM9.6875 11.2H19.3125L18.625 21H10.375L9.6875 11.2ZM13.125 12.6V19.6H13.8125V12.6H13.125ZM15.1875 12.6V19.6H15.875V12.6H15.1875Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.75,
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularTrash);
export default __webpack_public_path__ + "static/media/circular-trash.d585298f0aeeeda89d4ee08f44a2119c.svg";
export { ForwardRef as ReactComponent };